import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "../../../apiconfig";
import "./alert.css";
import logoutUser from "./logoutUser";

function PersonalInfo({ onNext, onPrev }) {

	const navigate = useNavigate();
	const [userInfo, setUserInfo] = useState({
		appNo: "",
		email: "",
		mobileNo: ""
	});

	useEffect(() => {
		const fetchData = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const res = await fetch(
					`${API_BASE_URL}/API/Student/GET_UNIQUE_DATA`,
					{
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				const data = await res.json();

				setUserInfo(data);

			} catch (err) {
				console.error(err);
			}
		};

		fetchData();
	}, []);

	const [selectedProgramcode, setSelectedProgramcode] = useState("");
	useEffect(() => {
		const fetchProgram = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PROGRAM_CODE`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("selected program code is:", data);

				if (data) {
					setSelectedProgramcode(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch program", err);
			}
		};

		fetchProgram();
	}, []);

	const [calculateage, setcalculateage] = useState("");
	useEffect(() => {
		const fetchCalculatedAge = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_CALCULATE_AGE`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const data = await response.text(); // since backend returns string
				console.log("calculated age is:", data);

				if (data) {
					setcalculateage(data); // ✅ auto select
				}

			} catch (err) {
				console.error("Failed to fetch age", err);
			}
		};

		fetchCalculatedAge();
	}, []);




	const [personalData, setPersonalData] = useState({
		name: "",
		fatherName: "",
		motherName: "",
		dob: "",
		nationality: "INDIAN",
		gender: "",
		assamResident: "",
		category: "",
		subCategory: "",
		categoryFlags: [],
		ews: ""
	});

	const [age, setAge] = useState("");

	const handleChange = (e) => {
		const { name, value } = e.target;

		setPersonalData({
			...personalData,
			[name]: value
		});

		if (name === "dob") calculateAge(value);
	};

	const handleCategoryChange = (e) => {
		setPersonalData({
			...personalData,
			category: e.target.value,
			subCategory: ""
		});
	};

	const handleSubCategoryChange = (e) => {
		setPersonalData({
			...personalData,
			subCategory: e.target.value
		});
	};

	/*const handleCheckboxChange = (e) => {
		const { value, checked } = e.target;

		// 🔥 SAFETY: ensure array
		let updated = Array.isArray(personalData.categoryFlags)
			? [...personalData.categoryFlags]
			: [];

		if (checked) {
			updated.push(value);
		} else {
			updated = updated.filter(item => item !== value);
		}

		setPersonalData({
			...personalData,
			categoryFlags: updated
		});
	};*/

	const handleCheckboxChange = (e) => {

		const { value, checked } = e.target;

		let updatedFlags = [...(personalData.categoryFlags || [])];

		if (value === "NONE") {

			// ✅ If NONE selected, remove all others
			if (checked) {
				updatedFlags = ["NONE"];
			} else {
				updatedFlags = [];
			}

		} else {

			// ✅ Remove NONE if other option selected
			updatedFlags = updatedFlags.filter(item => item !== "NONE");

			if (checked) {
				updatedFlags.push(value);
			} else {
				updatedFlags = updatedFlags.filter(item => item !== value);
			}
		}

		setPersonalData({
			...personalData,
			categoryFlags: updatedFlags
		});
	};

	const calculateAge = (dob) => {
		if (!dob) return;

		const d = new Date(dob);
		const ref = new Date("2026-07-01");

		let y = ref.getFullYear() - d.getFullYear();
		let m = ref.getMonth() - d.getMonth();
		let da = ref.getDate() - d.getDate();

		if (da < 0) { m--; da += 30; }
		if (m < 0) { y--; m += 12; }

		setAge(`${y} Years ${m} Months ${da} Days`);

	};

	const [alertData, setAlertData] = useState(null);
	const showAlert = (message, type = "error") => {
		setAlertData({
			message,
			type,
			id: Date.now()
		});

		setTimeout(() => {
			setAlertData(null);
		}, 5000);
	};

	useEffect(() => {
		fetchPersonalData();
	}, []);

	useEffect(() => {
		if (personalData.dob) {
			calculateAge(personalData.dob);
		}
	}, [personalData.dob]);

	const fetchPersonalData = async () => {
		try {
			const token = sessionStorage.getItem("token");

			const res = await fetch(
				`${API_BASE_URL}/API/Student/GET_PERSONAL_INFO`,
				{
					method: "GET",
					headers: {
						"Authorization": "Bearer " + token
					}
				}
			);

			if (res.status === 401 || res.status === 403) {

				logoutUser(navigate);
				return;
			}

			if (!res.ok) {
				console.error("Failed to fetch program");
				return;
			}
			const data = await res.json();
			console.log("personal details is:", data);

			if (res.ok && data !== "NOT_FOUND") {
				setPersonalData({
					name: data.name || "",
					fatherName: data.fatherName || "",
					motherName: data.motherName || "",
					dob: data.dob || "",
					nationality: data.nationality || "INDIAN",
					gender: data.gender || "",
					assamResident: data.assamResident || "",
					category: data.category || "",
					subCategory: data.subCategory || "",

					// 🔥 IMPORTANT
					categoryFlags: Array.isArray(data.categoryFlags)
						? data.categoryFlags
						: data.categoryFlags
							? data.categoryFlags.split(",")  // fallback safety
							: [],
					ews: data.ews || ""

				});
			}

		} catch (err) {
			console.error("Fetch error:", err);
		}
	};

	const validatePersonalData = () => {

		//const nameRegex = /^[A-Za-z ]+$/;
		const nameRegex = /^[A-Za-z][A-Za-z ]*$/;
		if (!personalData.name || personalData.name.trim() === "") {
			showAlert("Full Name is required ❗", "error");
			return false;
		}
		if (personalData.name.length > 40) {
			showAlert("Full Name max 40 characters ❗", "error");
			return false;
		}
		if (!nameRegex.test(personalData.name)) {
			showAlert("Full Name must contain only alphabets & no white spaces ❗", "error");
			return false;
		}

		if (!personalData.fatherName || personalData.fatherName.trim() === "") {
			showAlert("Father Name is required ❗", "error");
			return false;
		}
		if (personalData.fatherName.length > 40) {
			showAlert("Father Name max 40 characters ❗", "error");
			return false;
		}
		if (!nameRegex.test(personalData.fatherName)) {
			showAlert("Father Name must contain only alphabets & no white spaces ❗", "error");
			return false;
		}

		if (!personalData.motherName || personalData.motherName.trim() === "") {
			showAlert("Mother Name is required ❗", "error");
			return false;
		}
		if (personalData.motherName.length > 40) {
			showAlert("Mother Name max 40 characters ❗", "error");
			return false;
		}
		if (!nameRegex.test(personalData.motherName)) {
			showAlert("Mother Name must contain only alphabets & no white spaces ❗", "error");
			return false;
		}

		if (!personalData.dob) {
			showAlert("Date of Birth is required ❗", "error");
			return false;
		}

		if (!personalData.nationality) {
			showAlert("Nationality is required ❗", "error");
			return false;
		}

		if (!personalData.gender) {
			showAlert("Please select Gender ❗", "error");
			return false;
		}

		if (!personalData.assamResident) {
			showAlert("Please select Assam Resident ❗", "error");
			return false;
		}

		if (!personalData.category) {
			showAlert("Please select Category ❗", "error");
			return false;
		}

		if (personalData.category === "5 - OTHER BACKWARD CLASSES/MORE OTHER BACKWARD CLASSES ( NON CREAMY LAYER )" && !personalData.subCategory) {
			showAlert("Please select Sub Category ❗", "error");
			return false;
		}

		if (!personalData.categoryFlags || personalData.categoryFlags.length === 0) {
			showAlert("Please select at least one Special Reservation ❗", "error");
			return false;
		}

		if (!personalData.ews) {
			showAlert("Please select Economically Weaker Section ❗", "error");
			return false;
		}
		const programCode = selectedProgramcode?.toString().replace(/^0+/, "");

		const ageMatch = age.match(/(\d+)\s*Years\s*(\d+)\s*Months\s*(\d+)\s*Days/i);

		let ageYears = 0;
		let ageMonths = 0;
		let ageDays = 0;

		if (ageMatch) {
			ageYears = parseInt(ageMatch[1]);
			ageMonths = parseInt(ageMatch[2]);
			ageDays = parseInt(ageMatch[3]);
		}

		if (programCode === "01" || programCode === "1") {

			if (
				isNaN(ageYears) ||
				ageYears < 20 ||
				ageYears > 26 ||
				(ageYears === 26 && (ageMonths > 0 || ageDays > 0))
			) {
				showAlert("Age must be between 20 to 26 years for this program.", "error");
				return false;
			}
		}

		/*if (personalData.categoryFlags.length > 3) {
			showAlert("Maximum 3 selections allowed ❗", "error");
		   return false;
		}*/
		return true;
	};

	const handleNext = async () => {
		if (!validatePersonalData()) return;
		try {
			const token = sessionStorage.getItem("token");

			const response = await fetch(
				`${API_BASE_URL}/API/Student/SAVE_PERSONAL_INFO`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						"Authorization": "Bearer " + token
					},
					body: JSON.stringify({
						...personalData,
						age: age   // ✅ ADD SEPARATE STATE HERE
					})
				}
			);

			if (response.status === 401) {
				sessionStorage.clear();

				showAlert("Session expired ❗ Please login again", "error");

				setTimeout(() => {
					window.location.href = "/ASTU_JMEE_JLEE/Login";
				}, 1000);

				return;
			}
			const result = await response.text();
			console.log("API Result:", result);

			if (!response.ok) {
				throw new Error(result);
			}

			// 🔥 HANDLE CASES

			if (result === "PROGRAM_SELECTION_INCOMPLETE") {
				showAlert("Please select program first ❗", "error");

				// 👉 go back to previous step
				setTimeout(() => {
					onPrev(); // 🔥 GO BACK
				}, 800);

				return;
			}

			if (result === "SAVED") {
				showAlert("Saved successfully ✅", "success");

				setTimeout(() => {
					onNext(); // 👉 move forward
				}, 600);
			}

		} catch (err) {
			console.error(err);
			showAlert("Error saving data ❗", "error");
		}
	};

	const [isPaymentDone, setIsPaymentDone] = useState(false);

	useEffect(() => {
		const checkPaymentStatus = async () => {
			try {
				const token = sessionStorage.getItem("token");

				const response = await fetch(
					`${API_BASE_URL}/API/Student/GET_PAYMENT_DONE_OR_NOT`,
					{
						method: "GET",
						headers: {
							"Authorization": "Bearer " + token
						}
					}
				);

				if (!response.ok) return;

				const result = await response.json(); // boolean true/false
				console.log("Payment Done:", result);

				setIsPaymentDone(result);



			} catch (error) {
				console.error("Error checking payment:", error);
			}
		};

		checkPaymentStatus();
	}, []);
	
	const [isEditOn, setIsEditOn] = useState(false);
		useEffect(() => {
				const checkPaymentStatus = async () => {
					try {
						const token = sessionStorage.getItem("token");

						const response = await fetch(
							`${API_BASE_URL}/API/Student/EDIT_ON_OFF`,
							{
								method: "GET",
								headers: {
									"Authorization": "Bearer " + token
								}
							}
						);

						if (!response.ok) return;

						const result = await response.json(); 
						console.log("edit response:", result);

						setIsEditOn(result);



					} catch (error) {
						console.error("Error checking payment:", error);
					}
				};

				checkPaymentStatus();
			}, []);
			
			//const canEdit = !isPaymentDone || isEditOn === false;
			const canEdit = isEditOn === false;

	const categoryFullForms = {
		TGLE: "Tea Garden Labourer",
		FFE: "Freedom Fighter",
		ExTG: "Ex Tea Garden",
		EXD: "Ex Defence",
		CGE: "Central Government Employee",
		NCC: "National Cadet Corps",
		SPT: "Sports Quota",
		PwD: "Persons with Disabilities",
		TFW: "Tuition Fee Waiver",
		NONE: "None"
	};

	return (
		<>
			<style>{`

		@keyframes smoothEntry {
		0% {
			opacity: 0;
		    transform: translateY(20px);
	  	  }
		100% {
		   opacity: 1;
		   transform: translateY(0);
		 }
		}
		.container {
		  width: 100%;
		  max-width: 900px;
		  margin: 15px auto;

		  background: #fff;
		  padding: 16px 18px;

		  border-radius: 10px;
		  border: 1px solid #e2e8f0;
		  height: 600px;
		  animation: smoothEntry 0.4s ease;
		}

		/* TITLE */
		.title {
		  font-size: 17px;
		  font-weight: 600;
		  color: #065f46;
		  margin-bottom: 8px;
		}

		.info {
		  display: flex;
		  flex-wrap: wrap;
		  gap: 18px;

		  background: #f9fafb;           /* very light grey */
		  border: 1px solid #e5e7eb;

		  padding: 10px 14px;
		  border-radius: 6px;

		  font-size: 13px;
		  color: #374151;

		  margin-bottom: 14px;
		}

		/* each item */
		.info span {
		  display: flex;
		  align-items: center;
		  gap: 4px;
		}

		/* label */
		.info b {
		  color: #111827;
		  font-weight: 500;
		}

		/* 🔥 PERFECT ROW ALIGNMENT */
		.row {
		  display: flex;
		  gap: 14px;
		  margin-bottom: 12px;
		}

		/* equal width */
		.field {
		  flex: 1;
		  position: relative;
		}

		/* INPUT FIX */
		.field input {
		  width: 100%;
		  height: 38px;

		  padding: 12px 10px 4px;
		  font-size: 13px;

		  border: 1px solid #cbd5e1;
		  border-radius: 6px;
		  background: #fff;

		  outline: none;
		}

		/* SAME HEIGHT EVERYWHERE */
		.field input,
		.readonly {
		  box-sizing: border-box;
		}

		/* FLOAT LABEL (clean alignment) */
		.field label {
		  position: absolute;
		  left: 10px;
		  top: 11px;

		  font-size: 12.5px;
		  color: #64748b;

		  background: #fff;
		  padding: 0 4px;

		  transition: 0.15s ease;
		}

		/* FLOAT */
		.field input:focus + label,
		.field input:not(:placeholder-shown) + label {
		  top: -6px;
		  font-size: 10.5px;
		  color: #059669;
		}

		/* READONLY */
		.readonly {
		  background: #f8fafc;
		  color: #475569;
		}

		/* 🔥 RADIO ALIGN FIX */
		.radio-row {
		  margin-top: 8px;
		  margin-bottom: 12px;
		}

		.title-label {
		  font-size: 13px;
		  font-weight: 500;
		  color: #065f46;
		  display: block;
		  margin-bottom: 4px;
		}

		.radio-group {
		  display: flex;
		  gap: 20px;
		  align-items: center;
		}

		.radio-group label {
		  font-size: 13px;
		}

		/* BUTTONS ALIGN */
		.footer {
		  display: flex;
		  justify-content: space-between;
		  margin-top: 16px;
		}

		.btn {
		  padding: 6px 14px;
		  font-size: 13px;
		  border-radius: 6px;
		  border: none;
		  cursor: pointer;
		}

		.prev {
		  background: #e2e8f0;
		}

		.next {
		  background: #059669;
		  color: #fff;
		}
		.dropdown-small {
		  padding: 8px 12px;
		  border-radius: 8px;
		  border: 1px solid #cfd3ff;
		  font-size: 13px;
		  min-width: 260px;

		  background: #ffffff;
		  color: #333;

		  transition: all 0.25s ease;
		  outline: none;
		  cursor: pointer;

		  /* remove default ugly arrow (optional) */
		  appearance: none;
		  -webkit-appearance: none;
		  -moz-appearance: none;

		  /* custom arrow */
		  background-image: url("data:image/svg+xml;utf8,<svg fill='%236a5cff' height='20' viewBox='0 0 24 24' width='20' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
		  background-repeat: no-repeat;
		  background-position: right 10px center;
		  background-size: 16px;
		}

		/* 🔥 hover */
		.dropdown-small:hover {
		  border-color: #6a5cff;
		}

		/* 🔥 focus */
		.dropdown-small:focus {
		  border-color: #6a5cff;
		  box-shadow: 0 0 0 2px rgba(106, 92, 255, 0.15);
		}

		/* disabled look */
		.dropdown-small:disabled {
		  background: #f5f5f5;
		  cursor: not-allowed;
		  color: #999;
		}
		.checkbox-group {
			display: flex;
			flex-wrap: wrap;
			gap: 15px; /* ✅ space between checkboxes */
		}

		.checkbox-group label {
			display: flex;
			align-items: center;
			gap: 5px; /* ✅ space between checkbox and text */
		}
		
		@media (max-width: 768px) {

		  /* 🔥 container fix */
		  .container {
		    margin: 10px;
		    padding: 14px;
		    height: auto;              /* ❌ remove fixed height */
		    border-radius: 8px;
		  }

		  /* 🔥 rows stack vertically */
		  .row {
		    flex-direction: column;
		    gap: 10px;
		  }

		  /* 🔥 full width fields */
		  .field {
		    width: 100%;
		  }

		  .field input {
		    height: 42px;
		    font-size: 14px;
		  }

		  /* 🔥 labels slightly smaller */
		  .field label {
		    font-size: 11.5px;
		  }

		  .field input:focus + label,
		  .field input:not(:placeholder-shown) + label {
		    font-size: 9.5px;
		  }

		  /* 🔥 info section stack */
		  .info {
		    flex-direction: column;
		    gap: 6px;
		    font-size: 12px;
		  }

		  /* 🔥 radio group wrap */
		  .radio-group {
		    flex-wrap: wrap;
		    gap: 10px;
		  }

		  /* 🔥 dropdown full width */
		  .dropdown-small {
		    width: 100%;
		    min-width: unset;
		    font-size: 14px;
		  }

		  /* 🔥 buttons full width */
		  .footer {
		    flex-direction: column;
		    gap: 10px;
		  }

		  .btn {
		    width: 100%;
		    padding: 10px;
		    font-size: 14px;
		  }

		}

      `}</style>

			{alertData && (
				<div className={`custom-alert ${alertData.type}`}>
					<span className="alert-icon">
						{alertData.type === "success" ? "✔" : "❗"}
					</span>
					{alertData.message}
				</div>
			)}

			<div className="container">

				<div className="title">Personal Information</div>

				<div className="info">
					<span><b>Application No :</b> {userInfo.appNo}</span>
					<span><b>Email :</b> {userInfo.email}</span>
					<span><b>Mobile No. :</b> {userInfo.mobileNo}</span>
				</div>

				{/* Row 1 */}
				<div className="row">
					<div className="field">
						<input name="name" autoComplete="off" value={personalData.name} onChange={handleChange} placeholder=" " maxLength={40} disabled={!canEdit} />
						<label>Full Name *</label>
					</div>

					<div className="field">
						<input type="date" name="dob" autoComplete="off" value={personalData.dob} onChange={handleChange} placeholder=" " disabled={!canEdit} />
						<label>Date of Birth *</label>
					</div>
				</div>

				{/* Row 2 */}
				<div className="row">
					<div className="field">
						<input name="fatherName" value={personalData.fatherName} autoComplete="off" onChange={handleChange} placeholder=" " maxLength={40} disabled={!canEdit} />
						<label>Father Name *</label>
					</div>

					<div className="field">
						<input name="motherName" value={personalData.motherName} autoComplete="off" onChange={handleChange} placeholder=" " maxLength={40} disabled={!canEdit} />
						<label>Mother Name *</label>
					</div>
				</div>

				{/* Row 3 */}
				<div className="row">
					<div className="field">
						<input value={age || ""} readOnly className="readonly" placeholder=" " disabled={!canEdit} />
						<label>Age (01/07/2026)</label>
					</div>

					<div className="field">
						<input value="INDIAN" readOnly className="readonly" placeholder=" " disabled={!canEdit} />
						<label>Nationality</label>
					</div>
				</div>

				{/* Gender */}
				<div className="radio-row">
					<label className="title-label">Gender *</label>
					<div className="radio-group">
						<label><input type="radio" name="gender" value="MALE" checked={personalData.gender === "MALE"} onChange={handleChange} disabled={!canEdit} /> Male</label>
						<label><input type="radio" name="gender" value="FEMALE" checked={personalData.gender === "FEMALE"} onChange={handleChange} disabled={!canEdit} /> Female</label>
					</div>
				</div>

				{/* Assam */}
				<div className="radio-row">
					<label className="title-label">Permanent Resident of Assam?</label>
					<div className="radio-group">
						<label><input type="radio" name="assamResident" value="YES" checked={personalData.assamResident === "YES"} onChange={handleChange} disabled={!canEdit} /> Yes</label>
						<label><input type="radio" name="assamResident" value="NO" checked={personalData.assamResident === "NO"} onChange={handleChange} disabled={!canEdit} /> No</label>
					</div>
				</div>

				<div className="radio-row">
					<label className="title-label">Category</label>

					<select
						name="category"
						value={personalData.category}
						onChange={handleCategoryChange}
						className="dropdown-small"
						disabled={!canEdit}
					>
						<option value="">[SELECT]</option>
						<option value="1 - UNRESERVED CATEGORY (UR)">1 - UNRESERVED CATEGORY (UR)</option>
						<option value="2 - SCHEDULED CASTE">2 - SCHEDULED CASTE</option>
						<option value="3 - SCHEDULED TRIBE(PLAINS)">3 - SCHEDULED TRIBE(PLAINS)</option>
						<option value="4 - SCHEDULED TRIBE(HILLS)">4 - SCHEDULED TRIBE(HILLS)</option>
						<option value="5 - OTHER BACKWARD CLASSES/MORE OTHER BACKWARD CLASSES ( NON CREAMY LAYER )">5 - OTHER BACKWARD CLASSES/MORE OTHER BACKWARD CLASSES ( NON CREAMY LAYER )</option>

					</select>
				</div>

				{personalData.category === "5 - OTHER BACKWARD CLASSES/MORE OTHER BACKWARD CLASSES ( NON CREAMY LAYER )" && (
					<div className="radio-row">
						<label className="title-label">Sub Category</label>

						<div className="radio-group">
							<label>
								<input
									type="radio"
									name="subCategory"
									value="MORAN"
									checked={personalData.subCategory === "MORAN"}
									onChange={handleSubCategoryChange}
									disabled={!canEdit}
								/> Moran
							</label>

							<label>
								<input
									type="radio"
									name="subCategory"
									value="MOTAK"
									checked={personalData.subCategory === "MOTAK"}
									onChange={handleSubCategoryChange}
									disabled={!canEdit}
								/> Motak
							</label>

							<label>
								<input
									type="radio"
									name="subCategory"
									value="OTHER"
									checked={personalData.subCategory === "OTHER"}
									onChange={handleSubCategoryChange}
									disabled={!canEdit}
								/> Other
							</label>
						</div>
					</div>
				)}


				<div className="radio-row">
					<div className="checkbox-group">

						{["TGLE", "FFE", "ExTG", "EXD", "CGE", "NCC", "SPT", "PwD", "TFW", "NONE"].map((item) => (
							<label key={item}
								title={categoryFullForms[item]}
								style={{ cursor: "pointer" }}
							>
								<input
									type="checkbox"
									value={item}
									checked={(personalData.categoryFlags || []).includes(item)}
									onChange={handleCheckboxChange}
									disabled={!canEdit}
								/>
								{item}
							</label>
						))}

					</div>
				</div>

				<div className="radio-row">
					<label className="title-label">Do you belong to Economically Weaker Section (EWS) Category? </label>
					<div className="radio-group">
						<label><input type="radio" name="ews" value="YES" checked={personalData.ews === "YES"} onChange={handleChange} disabled={!canEdit} /> Yes</label>
						<label><input type="radio" name="ews" value="NO" checked={personalData.ews === "NO"} onChange={handleChange} disabled={!canEdit} /> No</label>
					</div>
				</div>




				{/* Footer */}
				<div className="footer">
					<button className="btn prev" onClick={onPrev}>⬅ Previous</button>
					<button className="btn next" onClick={handleNext}>Next ➜</button>
				</div>

			</div>
		</>
	);
}

export default PersonalInfo;